import $ from "jquery";
import IMask from "imask";
import { map as currencyMap, format } from "../../utils/currency";
import toastr from "../../utils/toastr";
import i18n from "../../utils/translate";
import throttle from "lodash/throttle";

const maskOptions = {
  mask: Number,
  scale: 2,
  signed: false,
  thousandsSeparator: " ",
  radix: ".",
  mapToRadix: [","],
  normalizeZeros: false
};

class Module {
  constructor($module) {
    this.depositTarget = $module.hasClass("wallet") ? "wallet" : "account";
    this.$calculationRequest = null;
    this.$container = $module;
    this.$method = $(".deposit_method");
    this.$forms = $module.find("form");
    this.$submitBtn = $(".deposit_submit");

    this.$admitadPaymentCurrencySelector = $(".admitad_paymentCurrency");
    this.$admitadPaymentCurrency = $("#admitad_paymentCurrency");

    this.$paymasterPaymentCurrencySelector = $(
      ".paymaster_wallet, .paymaster_ru_wallet"
    );

    this.$paymasterPaymentCurrency = $(
      "#paymaster_wallet, #paymaster_ru_wallet"
    );

    this.$paypalPaymentCurrencySelector = $(".paypal_paymentCurrency");
    this.$paypalPaymentCurrency = $("#paypal_paymentCurrency");

    this.$balanceDepositSelector = $(".user_balance_financialAccount");
    this.$balanceDeposit = $("#user_balance_financialAccount");
    this.$cashlessProfileSelector = $(".cashless_profile");
    this.$cashlessProfile = $("#cashless_profile");
    this.$payoneerPaymentCurrency = $("#payoneer_wallet");
    this.$payoneerPaymentCurrencySelector = $(".payoneer_wallet");
    this.$partnerWithdrawalDepositSelector = $(
      ".partner_withdrawal_financialAccount"
    );
    this.$partnerWithdrawalDeposit = $("#partner_withdrawal_financialAccount");

    this.currency = $module.data("currency");
    this.discount = parseFloat($module.data("discount"));
    this.commission = parseFloat($module.data("commission"));

    this.bind();

    $(".deposit_form:not(.hidden) > form .js-amount").trigger("change");
  }

  bind() {
    const self = this;

    this.$submitBtn.click(e => {
      e.preventDefault();

      if (this.$submitBtn.hasClass("disabled")) {
        return;
      }

      this.$submitBtn.addClass("disabled");

      if (!this.submit()) {
        this.$submitBtn.removeClass("disabled");
      }
    });

    this.$method.dropdown("setItemHandler", function(e) {
      e.preventDefault();
      self.switchMethod($(this).data("form"));
    });

    this.$admitadPaymentCurrencySelector.dropdown("setItemHandler", function(
      e
    ) {
      e.preventDefault();
      self.$admitadPaymentCurrency.val($(this).data("value")).trigger("change");
    });

    this.$paymasterPaymentCurrencySelector.dropdown("setItemHandler", function(
      e
    ) {
      e.preventDefault();
      $(this)
        .closest("form")
        .find("#paymaster_wallet, #paymaster_ru_wallet")
        .val($(this).data("value"))
        .trigger("change");
    });

    this.$paymasterPaymentCurrency.on("change", function() {
      const value = $(this).val();
      const $sumGroup = $(this)
        .closest("form")
        .find("#paymaster_sum, #paymaster_ru_sum")
        .closest(".form-group");

      if (value !== "WMR" && value !== "WMP") {
        $sumGroup.hide();
      } else {
        $sumGroup.show();
      }
    });

    this.$paypalPaymentCurrencySelector.dropdown("setItemHandler", function(e) {
      e.preventDefault();
      self.$paypalPaymentCurrency.val($(this).data("value")).trigger("change");
    });

    this.$balanceDepositSelector.dropdown("setItemHandler", function(e) {
      e.preventDefault();

      const currentForm = $(".deposit_form:not(.hidden) > form");

      $(".js-balance", currentForm).html(
        format($(this).data("balance"), $(this).data("currency"))
      );

      self.$balanceDeposit.val($(this).data("value")).trigger("change");
      $(".js-amount", currentForm).trigger("change");
    });

    this.$balanceDepositSelector
      .find(".b-dropdown__item_regular")
      .trigger("click");

    this.$partnerWithdrawalDepositSelector
      .find(".b-dropdown__item_regular")
      .trigger("click");

    this.$partnerWithdrawalDepositSelector.dropdown("setItemHandler", function(
      e
    ) {
      e.preventDefault();
      $(".js-amount").trigger("change");
      $(".js-balance").html(
        format($(this).data("balance"), $(this).data("currency"))
      );
      self.$partnerWithdrawalDeposit
        .val($(this).data("value"))
        .trigger("change");
    });

    this.$cashlessProfileSelector.dropdown("setItemHandler", function(e) {
      e.preventDefault();
      self.$cashlessProfile.val($(this).data("value")).trigger("change");
      $("form[name='cashless'] .js-amount").trigger("change");
    });

    this.$cashlessProfileSelector.find(".js-dropdown-active").trigger("click");

    this.$payoneerPaymentCurrencySelector.dropdown("setItemHandler", function(
      e
    ) {
      e.preventDefault();
      self.$payoneerPaymentCurrency
        .val($(this).data("value"))
        .trigger("change");
    });

    this.$payoneerPaymentCurrency
      .on("change", function() {
        if (!$(this).val()) {
          return;
        }

        const wallet = $(this).val();
        const balance = $(this).data("balance-" + wallet);
        const currency = $(this).data("currency-" + wallet);

        $(".js-payoneer-balance").html(format(balance, currency));
      })
      .trigger("change");

    this.$forms.each(function() {
      const $form = $(this);
      const $amount = $form.find(".js-amount");
      const $sum = $form.find(".js-sum");

      const $totalAmount = $form.find(".js-total-amount");
      const $currency = $form.find(".js-currency");

      const maskedAmount = $amount.length
        ? new IMask($amount[0], maskOptions)
        : null;

      const maskedSum = $sum.length ? new IMask($sum[0], maskOptions) : null;

      if ($form.is('[name="cashless"]')) {
        const $input = $form.find("#cashless_profile");

        $form
          .find(".js-choice-widget span")
          .text($input.data("currency-" + $input.val()));

        $input.on("change", function() {
          $form
            .find(".js-choice-widget span")
            .text($input.data("currency-" + $input.val()));
        });
      }

      $amount.on(
        "change keyup",
        throttle(function() {
          if (self.$calculationRequest) {
            self.$calculationRequest.abort();
          }

          const currency = $form.is('[name="cashless"]')
            ? $form.find(".js-choice-widget span").text()
            : $form.find(".js-currency").val() || "RUB";

          const data = {
            method: $form.attr("target"),
            payment_profile_id: parseInt(
              $form.find(".js-profile_choice input").val()
            ),
            payment_amount: {
              value: parseFloat(maskedAmount.unmaskedValue),
              currency: currency
            }
          };

          if ($form.attr("target") === "user_balance") {
            data.wallet_id = Number(self.$balanceDeposit.val());
            data.payment_amount.currency = self.$balanceDepositSelector
              .find(".js-dropdown .b-dropdown__item_regular")
              .data("currency");
          }

          if ($form.attr("target") === "cashless") {
            data.wallet_id = Number($("#cashless_wallet", $form).val());
          }

          if (
            self.depositTarget === "wallet" &&
            $form.attr("target") !== "cashless"
          ) {
            data.wallet_id = self.$container.data("wallet-id");
          }

          self.$submitBtn.addClass("disabled");

          if (!data.payment_amount.value) {
            return;
          }

          self.$calculationRequest = $.ajax({
            type: "POST",
            url:
              self.depositTarget === "wallet"
                ? "/api/app/v1/billing/wallet/calculate"
                : `/api/app/v1/billing/account/${self.$container.data(
                    "account-id"
                  )}/calculate`,
            data: JSON.stringify(data),
            contentType: "application/json",
            dataType: "json"
          })
            .always(function() {
              self.$submitBtn.removeClass("disabled");
            })
            .done(function({ data }) {
              if (self.depositTarget === "wallet") {
                $totalAmount.html(
                  format(
                    data.deposit.account.value,
                    data.deposit.account.currency
                  )
                );
              }

              if (self.depositTarget === "account") {
                $totalAmount.html(
                  format(
                    data.transfer.account.value,
                    data.transfer.account.currency
                  )
                );
              }

              $totalAmount.parent("form_group").addClass("form-group_focused");

              if (!!maskedSum) {
                maskedSum.unmaskedValue = "" + data.deposit.payment.value;
                $(maskedSum.el.input)
                  .parent(".form-group")
                  .addClass("form-group_focused");
              }
            });
        }, 750)
      );

      $currency.on("change", function() {
        $amount.trigger("change");
      });
    });
  }

  switchMethod(form) {
    $(".deposit_form:not(.hidden)").addClass("hidden");
    const $form = $(".deposit_form_" + form);
    $form.removeClass("hidden");
    $(".js-amount", $form).trigger("change");
  }

  submit() {
    const $form = this.$container.find(".deposit_form:not(.hidden) form");
    if (!$form.length) {
      return false;
    }

    const $amount = $form.find("[name*=amount]");
    const value = this.toFloat($amount.val());
    let min = $amount.attr("min") || 0;
    let currency = this.currency.toLowerCase();
    const $currencySelector = $form.find(".js-currency");
    const $walletSelector = $form.find("#user_balance_financialAccount");
    const $profileSelector = $form.find("#cashless_profile");

    let exchangeRate = 1;
    let paymentAmount = value;

    if ($currencySelector.length) {
      exchangeRate = parseFloat(
        $currencySelector.data(
          "rate-" + $currencySelector.val().toLowerCase()
        ) || 1
      );
      paymentAmount = value * exchangeRate;
    }

    if ($walletSelector.length) {
      exchangeRate = parseFloat(
        $walletSelector.data("rate-" + $walletSelector.val())
      );
      paymentAmount = value * exchangeRate;
    }

    if ($profileSelector.length) {
      currency = $profileSelector
        .data("currency-" + $profileSelector.val())
        .toLowerCase();
      min = $profileSelector.data("min-amount-" + $profileSelector.val());
    }

    if (currency in currencyMap) {
      currency = currencyMap[currency];
    }

    if (isNaN(value) || !isFinite(value) || paymentAmount < min) {
      toastr.error(i18n.gettext("deposit.min_msg", min, currency));
      return false;
    }

    $amount.val(value);

    const target = $form.attr("target");

    if (typeof target !== typeof undefined && target !== false) {
      const popupWindow = window.open(
        "",
        target,
        "width=800,height=600,toolbar=0,scrollbars=1,status=0,resizable=0,location=0,menuBar=0"
      );
      const timer = setInterval(() => {
        if (popupWindow && popupWindow.closed) {
          clearInterval(timer);
          this.$submitBtn.removeClass("disabled");
        }
      }, 1000);
    }

    $form.submit();
    return true;
  }

  parseValue(value) {
    value = this.toFloat(value);

    if (value < 0) {
      value = 0;
    }

    return value;
  }

  convert(value, rates, from, to) {
    value = this.parseValue(value);

    if (!rates) {
      return value;
    }

    return (value * (rates[from] / rates[to])).toFixed(2);
  }

  toFloat(val) {
    val = parseFloat(val.replace(/\s+/g, "").replace(/,/, "."));

    if (isNaN(val)) {
      return 0;
    }

    return val;
  }
}

$(function() {
  $(".js-billing-deposit").each(function() {
    new Module($(this));
  });
});
